/*
 * PrimeVue 4 DatePicker passthrough.
 *
 * Maps the popup calendar + time picker chrome to our handoff tokens.
 * Inherits InputText pt for the trigger field; overrides only the panel
 * and its sub-elements.
 */
const pt = {
    root: { class: 'relative inline-block w-full' },
    pcInputText: {
        root: {
            class: [
                'w-full px-3 py-2 pr-9 rounded-6',
                'border border-gray-200 bg-white',
                'text-sm text-gray-900 placeholder:text-gray-400',
                'transition-colors duration-fast',
                'focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20',
                'disabled:bg-gray-50 disabled:cursor-not-allowed'
            ]
        }
    },
    inputIconContainer: {
        class: 'absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex items-center'
    },
    inputIcon: { class: 'w-4 h-4' },
    panel: {
        class: [
            'mt-1 bg-white border border-gray-200 rounded-8 shadow-shm overflow-hidden',
            'p-3 z-dropdown text-sm text-gray-900',
            // PrimeVue inlines min-width = input.width when fluid is set; force a
            // sane fixed size for the calendar regardless.
            '!w-[330px] !min-w-0'
        ]
    },
    header: { class: 'flex items-center justify-between mb-3' },
    pcPrevButton: {
        root: {
            class: 'inline-flex items-center justify-center w-7 h-7 rounded-6 text-gray-500 hover:bg-gray-100'
        }
    },
    pcNextButton: {
        root: {
            class: 'inline-flex items-center justify-center w-7 h-7 rounded-6 text-gray-500 hover:bg-gray-100'
        }
    },
    title: { class: 'flex items-center gap-1 font-semibold text-sm text-ink' },
    selectMonth: { class: 'cursor-pointer hover:text-teal px-1' },
    selectYear: { class: 'cursor-pointer hover:text-teal px-1' },
    dayView: { class: 'w-full border-collapse' },
    weekHeader: { class: '' },
    weekDay: { class: 'p-1 text-[10px] uppercase font-semibold text-gray-400 text-center' },
    weekNumber: { class: 'p-1 text-[10px] text-gray-400' },
    dayCell: { class: 'p-0.5' },
    day: ({ context }: { context: { date: { otherMonth?: boolean; today?: boolean }; selected?: boolean } }) => ({
        class: [
            'inline-flex items-center justify-center w-7 h-7 rounded-6 text-xs cursor-pointer',
            'transition-colors duration-fast',
            context.selected ? 'bg-teal text-white font-semibold' : 'hover:bg-gray-100 text-gray-700',
            !context.selected && context.date?.today && 'border border-teal',
            context.date?.otherMonth && !context.selected && 'text-gray-300'
        ]
    }),
    timePicker: {
        class: 'flex items-center justify-center gap-2 mt-3 pt-3 border-t border-gray-200'
    },
    hourPicker: { class: 'flex flex-col items-center' },
    minutePicker: { class: 'flex flex-col items-center' },
    secondPicker: { class: 'flex flex-col items-center' },
    separator: { class: 'flex items-center text-gray-400' },
    pcIncrementButton: {
        root: {
            class: 'inline-flex items-center justify-center w-6 h-6 rounded-4 text-gray-500 hover:bg-gray-100'
        }
    },
    pcDecrementButton: {
        root: {
            class: 'inline-flex items-center justify-center w-6 h-6 rounded-4 text-gray-500 hover:bg-gray-100'
        }
    },
    buttonbar: {
        class: 'flex items-center justify-between gap-2 mt-3 pt-3 border-t border-gray-200'
    },
    pcTodayButton: {
        root: {
            class: [
                'inline-flex items-center justify-center px-3 h-7 rounded-6 text-xs font-semibold',
                'bg-white text-gray-700 border border-gray-200 hover:border-gray-300 hover:bg-gray-50'
            ]
        }
    },
    pcClearButton: {
        root: {
            class: [
                'inline-flex items-center justify-center px-3 h-7 rounded-6 text-xs font-semibold',
                'bg-white text-gray-700 border border-gray-200 hover:border-gray-300 hover:bg-gray-50'
            ]
        }
    }
}

export default pt
